import moment from 'moment';
import React, {Component, Fragment} from 'react';
import PropertyActions from '../../common/PropertyActions';
import {Storage} from "../../../../shared/services/aws";

class AttachmentListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {awsUrl: ''};
  }

  async componentDidMount() {
    const result = await this.getS3Link(this.props.attachment.s3Key);
    this.setState({awsUrl: result});
  }

  // ----------------------
  // Computed
  // ----------------------

  getAttachmentPropertyActions() {
    const deleteAttachment = {
      label: 'Delete',
      handlerProp: 'onDelete',
      icon: 'trash',
    };
    return [deleteAttachment];
  }

  async getS3Link(s3Key) {
    return new Promise((resolve, reject) => {

      Storage.get(`${s3Key}`)
        .then(result => resolve(result))
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    })

  }

  render() {
    return (
      <Fragment>
        <tr key={this.props.attachment.id}>
          <th scope="row">
            <a target="_blank" href={this.state.awsUrl}>
              {this.props.attachment.filename}
            </a>
          </th>
          <td>{this.props.attachment.creator.getFullName()}</td>
          <td>
            {moment(this.props.attachment.uploadedAt).format('HH:mm on MMM D, YYYY')}
          </td>
          {!this.props.disableEdit && (
            <td>
              <PropertyActions
                actions={this.getAttachmentPropertyActions()}
                onDelete={() => {
                  return this.props.onDelete(this.props.attachment);
                }}
              />
            </td>
          )}
        </tr>
      </Fragment>
    );
  }
}

export default AttachmentListItem;
